import { call, put, takeLatest } from 'redux-saga/effects';

/**
 * Класс для загрузки типовых словарей в стор, вместе с лоадером.
 * Удобно, если нужно вызвать только запрос, без экшна и дождаться его выполнения.
 */
export class DictionaryGeneratorContainer {
  constructor(actionType, dictionaryName, callable) {
    this.name = actionType;
    this.path = dictionaryName;
    this.callable = callable;
    this.sagaFunction = this.sagaFunction.bind(this);
  }

  sagaFunction = function* (action) {
    const response = yield call(this.callable, action ? action.payload : null);
    yield put(
      response.isOk
        ? {
            type: this.name + '.REQUEST_SUCCESS',
            payload: { data: response.data, params: action.payload },
          }
        : {
            type: this.name + '.REQUEST_FAILURE',
            payload: { error: response.error },
          },
    );
  };

  buildSagaFunction = function* () {
    yield takeLatest(this.name + '.REQUEST_START', this.sagaFunction);
  };
}
